export const Screens = {
  HOME: 'marketplace homepage',
  APPS: 'apps product homepage',
  AGENTS: 'agents product homepage',
  WORKFLOW_TEMPLATES: 'workflow templates product homepage',
  SOLUTIONS_PARTNERS: 'solutions partners homepage',
  SEARCH_RESULTS: 'search results',
  FEATURED: 'featured collections',
  FEATURED_COLLECTION: 'collection search results',
  UMBRELLA_COLLECTION: 'umbrella collection',
  LISTING_DETAILS: 'listing details',
  LISTING_DETAILS_REVIEW: 'listing details review',
  PROXY_REDIRECT: 'proxy redirect'
};
export const Subscreens = {
  ALL_PRODUCTS_SECTION: 'all products section',
  EXPLORE_ALL_WORKFLOW_TEMPLATES: 'explore all workflow templates',
  COLLECTION_SECTION: 'collection section',
  FILTER_BAR: 'filter bar',
  FILTER_PANEL: 'filter panel',
  HERO_SECTION: 'hero section',
  NO_RESULTS: 'no results',
  RESULTS_GRID: 'results grid',
  SEARCH_BAR: 'search bar',
  STOREFRONT_NAVIGATION: 'storefront navigation',
  SUGGESTION_SECTION: 'suggestion section',
  SUGGESTED_COLLECTIONS: 'suggested collections',
  SUGGESTED_ACCREDITATIONS: 'suggested accreditations',
  RECOMMENDED_PARTNERS: 'recommended partners',
  PARTNER_TIER_EXPLAINER: 'partner tier explainer',
  PROXY_ALL_APPS: 'all apps',
  PROXY_APP_CATEGORY: 'app category',
  PROXY_ALL_AGENTS: 'all agents',
  PROXY_AGENT_TEAM: 'agent team',
  PROXY_ALL_SOLUTIONS_PARTNERS: 'all solutions partners',
  PROXY_SOLUTIONS_CATEGORY: 'solutions category',
  PROXY_SOLUTIONS_SUBCATEGORY: 'solutions subcategory',
  PROXY_SOLUTIONS_SUBCATEGORY2: 'solutions subcategory2'
};